import { IAppointment, IFinancial } from '@/interfaces';
import { FinancialState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setFinancials(state: FinancialState, payload: IFinancial[]) {
    state.financials = payload;
  },
  setUnattestedAppointments(state: FinancialState, payload: IAppointment[]) {
    state.unattestedAppointments = payload;
  },
  setAppointmentsWithoutPrescription(state: FinancialState, payload: IAppointment[]) {
    state.appointmentsWithoutPrescription = payload;
  },
};

const { commit } = getStoreAccessors<FinancialState, State>('');

export const commitSetFinancials = commit(mutations.setFinancials);
export const commitSetUnattestedAppointments = commit(mutations.setUnattestedAppointments);
export const commitSetAppointmentsWithoutPrescription = commit(mutations.setAppointmentsWithoutPrescription);
